
import { ToastContainer } from "react-bootstrap";
import { Loader } from "rsuite";
import PageTitle from "../../layouts/PageTitle";
import PhoneInput from "react-phone-input-2";
import { addSupplier } from "../../../services/apis/Supplier";
import BasicInformation from "../../components/CreateAgency/BasicInformation";
import { useState } from "react";
import CompanyAddress from "../../components/CreateAgency/CompanyAddress";
import SocialHandles from "../../components/CreateAgency/SocialHandles";
import ComplianceVerification from "../../components/CreateAgency/ComplianceVerification";


const AddAgency = () => {
    const [tabValue, setTabValue] = useState("Basic-Information");
    const [agencyId, setAgencyId] = useState("Basic-Information");

  return (
    <>

      <ToastContainer />
      {/* <Loader /> */}
      <PageTitle activeMenu={"Agency"} motherMenu={"Home"} />
      <div className="col-xl-12 col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Add Agency</h4>
            </div>
            <div className="card-body">
             <div className="row">
               {/* SECTION 1ST */}
                 <div className="row mb-5 mt-2">
                  <div className="tab-container">
                      <button
                          className={`${tabValue === "Basic-Information" ? "create-event-active-tab" : "create-event-tab"}`}
                          onClick={() => setTabValue("Basic-Information")}>
                           Basic Information
                      </button>

                      <button
                          className={`${tabValue === "Company-Address" ? "create-event-active-tab" : "create-event-tab"}`}
                          onClick={() => setTabValue("Company-Address")}>
                         Company Address
                      </button> 
                      
                      <button
                          className={`${tabValue === "Social-Handles" ? "create-event-active-tab" : "create-event-tab"}`}
                          onClick={() => setTabValue("Social-Handles")}>
                           Social Handles
                      </button>
                     
                      <button
                          className={`${tabValue === "Compliance-Verification" ? "create-event-active-tab" : "create-event-tab"}`}
                          onClick={() => setTabValue("Compliance-Verification")}>
                          Compliance Verification
                      </button>

                      {/* <button
                          className={`${tabValue === "Compliance-Verification" ? "create-event-active-tab" : "create-event-tab"}`}
                          onClick={() => setTabValue("Compliance-Verification")}>
                         Compliance & Verification
                      </button> */}
                  </div>
                  
                  <div className="row mt-5">
                      {tabValue == "Basic-Information" ? (
                         <div className="">
                             <BasicInformation setAgencyId={setAgencyId} setTabValue={setTabValue} />
                         </div>
                      ) : 
                      tabValue == "Company-Address" ? (
                        <div className="">
                            <CompanyAddress agencyId={agencyId} setTabValue={setTabValue} />
                        </div>
                      )
                      : 
                      tabValue == "Social-Handles" ? (
                        <div className="">
                            <SocialHandles agencyId={agencyId} setTabValue={setTabValue} />
                        </div>
                      )
                      :
                      tabValue == "Compliance-Verification" ? (
                        <div className="">
                            <ComplianceVerification agencyId={agencyId} setTabValue={setTabValue} />
                        </div>
                      )
                      : (
                          ""
                      )}
                  </div>
              </div>
              </div>
              </div>
              </div>
        {/* <div className="col-xl-12 col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Add Agency</h4>
            </div>
            <div className="card-body">
              <div>
                <div className="mb-3 row">
                  <div className="col-md-6">
                    <label className="col-sm-6 col-form-label">Agency Name</label>
                    <input
                      name="name"
                      type="text"
                      className="form-control"
                      placeholder="Ex: ABC"
                    />

                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-md-6 col-xl-3">
                    <label className="col-form-label">Contact Person First Name</label>
                    <input
                      name="firstName"
                      type="text"
                      className="form-control"
                      placeholder="Ex: ABC"
                    />

                  </div>

                  <div className="col-md-6 col-xl-3">
                    <label className="col-form-label">Contact Person Last Name</label>
                    <input
                      name="lastName"
                      type="text"
                      className="form-control"
                      placeholder="Ex: ABC"
                    />
                  </div>


                  <div className="col-md-6 col-xl-3">
                    <label className="col-md-8 col-form-label">Phone</label>
                    <PhoneInput
                      className=""
                      inputClass=""
                      country={"in"}

                    />
                  </div>


                  <div className="col-md-6 col-xl-3">
                    <label className="col-sm-6 col-form-label">Email</label>
                    <input
                      name="email"
                      type="email"
                      required="email"
                      className="form-control"
                      placeholder="Ex: ABC"
                    />
                  </div>
                </div>


                <div className="mb-3 row">
                  <div className="col-sm-3">
                    <label className="col-sm-4 col-form-label">State</label>
                    <input
                      name="state"
                      type="text"
                      className="form-control"
                      placeholder="Ex:state"
                    />
                  </div>

                  <div className="col-sm-3">
                    <label className="col-sm-4 col-form-label">City</label>
                    <input
                      name="city"
                      type="text"
                      className="form-control"
                      placeholder="Ex: city"
                    />
                  </div>


                  <div className="col-sm-3">
                    <label className="col-sm-8 col-form-label">PinCode</label>
                    <input
                      name="pincode"
                      type="number"
                      className="form-control"
                      placeholder="Ex: 123"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-sm-6">
                    <label className="col-sm-6 col-form-label">Address</label>
                    <input
                      name="address"
                      type="text"
                      className="form-control"
                      placeholder="Ex: ABC"
                    />
                  </div>
                </div>


                <div className="mb-3 row">
                  <div className="col-sm-8">
                    <label className="col-sm-3 col-form-label">
                      Description
                    </label>
                    <textarea
                      name="description"
                      className="form-control"
                      rows="6"
                      id="comment"
                      placeholder="Ex: House#94  Road#8  Abc City"

                    ></textarea>

                  </div>
                </div>
              </div>
              <div className="text-end">
                <button
                  type="submit"
                  className="btn btn-primary rounded-sm">
                  Save Information
                </button>
              </div>
            </div>

          </div>
        </div> */}
        {/* Section Submit button */}
      </div>
    </>
  );
};

export default AddAgency;
